module.exports = __webpack_public_path__ + "75a304f3da0dac024fc01c609fcbdc1f.svg";